<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="doctmpl-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Szablony dokumentów</h1>
      </div>
      <button class="action-pill action-pill--primary" @click="dialog = true">
        <v-icon size="14">mdi-plus</v-icon>{{ $t('common.add') }}
      </button>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="documentTemplates || []"
          class="elevation-1"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
        >
          <template v-slot:top>
            <div class="table-section-title">
              <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-file-document-multiple</v-icon></div>
              <div class="filter-title">{{ $t('documentTemplates.title') }}</div>
            </div>
          </template>
          <template v-slot:item.isRequiredForDriver="{ item }">
            <v-icon v-if="item.isRequiredForDriver" color="green">mdi-check</v-icon>
            <v-icon v-else color="red">mdi-close</v-icon>
          </template>
          <template v-slot:item.downloadTemplate="{ item }">
            <v-btn class="warning" @click="downloadTemplate(item.fileId)" :disabled="!item.fileId"
              ><v-icon small class="pt-1">mdi-download</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteDocumentTemplate="{ item }">
            <v-btn class="error" @click="deleteDocumentTemplate(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Dialog do wgrywania dokumentu -->
    <v-dialog v-model="dialog" max-width="600px" content-class="dark-form-dialog">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ $t('documentTemplates.uploadTemplate') }}</span>
        </v-card-title>
        <v-card-text>
          <!-- Formularz do wgrywania dokumentu -->
          <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="templateName"
                  :label="$t('documentTemplates.templateName')"
                  outlined
                  dense
                  required
                  :rules="[validateRequired]"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-file-input
                  v-model="file"
                  :label="$t('documentTemplates.uploadDocx')"
                  accept=".docx"
                  outlined
                  dense
                  prepend-icon=""
                  prepend-inner-icon="mdi-upload"
                  @change="processFile"
                ></v-file-input>
              </v-col>
              <v-col cols="12">
                <div v-if="variables.length">
                  <h3 class="text-subtitle-2 mb-2">{{ $t('documentTemplates.extractedVariables') }}:</h3>
                  <ul class="variable-list">
                    <li v-for="(variable, index) in variables" :key="index">
                      {{ variable }}
                    </li>
                  </ul>
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="isRequiredForDriver"
                  :label="$t('documentTemplates.requiredForDriver')"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" @click="submitForm" :disabled="!valid"
            >{{ $t('documentTemplates.upload') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mammoth from "mammoth";
import Swal from "sweetalert2";
const axios = require("axios");

export default {
  data() {
    return {
      variables: [],
      file: null,
      templateName: null,
      isRequiredForDriver: false,
      documentTemplates: [],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      totalItems: 0,
      headers: [
        {
          text: "Nazwa",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Nazwa Dokumentu",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Wymagane dla kierowcy", value: "isRequiredForDriver", sortable: false },
        { text: "", value: "downloadTemplate", sortable: false },
        { text: "", value: "deleteDocumentTemplate", sortable: false },
      ],
      loading: false,
      dialog: false, // Kontroluje widoczność dialogu
      valid: false, // Walidacja formularza
      rules: {
        required: (value) => !!value || "Wymagane.",
        email: (value) => /.+@.+\..+/.test(value) || "Nieprawidłowy email.",
        password: (value) =>
          value.length >= 6 || "Hasło musi mieć co najmniej 6 znaków.",
      },
    };
  },
  methods: {
    async processFile() {
      if (!this.file) return;

      const reader = new FileReader();

      reader.onload = async (event) => {
        try {
          const arrayBuffer = event.target.result;
          const result = await mammoth.extractRawText({ arrayBuffer });
          const extractedText = result.value;

          // Wyodrębnij zmienne w nawiasach {{ }} lub { } (obsługa obu).
          // [^{}] zapobiega łapaniu śmieci przez chciwe dopasowanie przez nawiasy.
          const found = [...extractedText.matchAll(/\{\{?\s*([^{}]+?)\s*\}\}?/g)]
            .map((m) => m[1].trim())
            .filter(Boolean);
          // Unikalne, z zachowaniem kolejności.
          this.variables = [...new Set(found)];
        } catch (error) {
          Swal.fire("Błąd", "Błąd przy procesowaniu pliku!", "error");
        }
      };

      reader.readAsArrayBuffer(this.file);
    },
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    async downloadTemplate(id) {
      const file = await axios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "aws/download-file/" + id,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        responseType: "blob",
      });
      console.log(file);
      let blob = new Blob([file.data], { type: file.data.type }),
        url = window.URL.createObjectURL(blob);
      window.open(url);
    },
    async deleteDocumentTemplate(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "documents/templates/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    // Obsługa wysłania formularza (wgrywanie dokumentu)
    async submitForm() {
      // Walidacja pliku i wywołanie API do wgrania dokumentu
      if (!this.valid) return;

      const formData = new FormData();
      try {
        formData.append("file", this.file, this.file.name);
      } catch (e) {
        console.log("Brak pliku");
      }
      formData.append("name", this.templateName);
      formData.append("metadata", JSON.stringify(this.variables));
      formData.append("isRequiredForDriver", this.isRequiredForDriver);
      try {
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "documents/templates",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });

        // Zamknij dialog i zresetuj formularz
        this.dialog = false;
        this.templateName = null;
        this.file = null;
        this.variables = [];
        this.isRequiredForDriver = false;
        this.$refs.form.reset();

        // Odśwież dane
        await this.initialize();

        // Pokaż komunikat sukcesu
        Swal.fire("Sukces", "Szablon został dodany pomyślnie", "success");
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async initialize() {
      this.loading = true;
      try {
        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "documents/templates",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          params: {
            take: this.options.itemsPerPage,
            skip: this.options.page,
          },
        });
          this.documentTemplates = response.data.data.result.map(t => ({
            ...t,
            fileId: t.file && t.file.length > 0 ? t.file[0].id : null,
          }));
          this.totalItems = response.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", "Nie udało się pobrać szablonów", "error");
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.doctmpl-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.action-pill { display: inline-flex; align-items: center; gap: 6px; background: #181C28; border: 1px solid rgba(255,255,255,0.08); color: #fff; padding: 8px 14px; border-radius: 10px; font-size: 12.5px; font-weight: 600; letter-spacing: -0.01em; cursor: pointer; transition: transform 0.12s ease, background 0.15s ease, border-color 0.15s ease; font-family: inherit; }
.action-pill:hover { transform: translateY(-1px); border-color: rgba(255,255,255,0.18); }
.action-pill .v-icon { color: inherit !important; }
.action-pill--primary { background: #2962FF; border-color: #2962FF; box-shadow: 0 4px 12px rgba(41,98,255,0.3); }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; letter-spacing: -0.01em; flex-grow: 1; }

.doctmpl-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.doctmpl-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.doctmpl-page >>> .v-text-field--outlined fieldset, .doctmpl-page >>> .v-select--outlined fieldset, .doctmpl-page >>> .v-textarea--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.doctmpl-page >>> .v-text-field--outlined .v-input__slot, .doctmpl-page >>> .v-select--outlined .v-input__slot, .doctmpl-page >>> .v-textarea--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.doctmpl-page >>> .v-text-field input, .doctmpl-page >>> .v-select__selection, .doctmpl-page >>> .v-textarea textarea { color: #fff !important; }
.doctmpl-page >>> .v-text-field:not(.v-text-field--outlined) input, .doctmpl-page >>> .v-text-field:not(.v-text-field--outlined) textarea { color: #fff !important; }
.doctmpl-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.doctmpl-page >>> .v-label { color: #6E7691 !important; }
.doctmpl-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.doctmpl-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.doctmpl-page >>> .v-data-table tbody tr { background: #232838 !important; }
.doctmpl-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.doctmpl-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.doctmpl-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.doctmpl-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.doctmpl-page >>> .v-btn:not(.v-btn--icon):not(.action-pill) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.doctmpl-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.doctmpl-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.doctmpl-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.doctmpl-page >>> .v-dialog .v-card { background: #232838 !important; }
.variable-list {
  background: #1F2433;
  border: 1px solid #2A3142;
  border-radius: 8px;
  padding: 12px 12px 12px 28px;
  color: #E6EAF2;
  font-size: 13px;
  margin: 0;
}
.variable-list li {
  padding: 2px 0;
}
</style>
